import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { capturerParrainage } from '../../lib/parrainage';

/**
 * Capte le paramètre ?ref sur TOUTE page de l'application, pas seulement
 * l'inscription : un parent qui arrive par le lien d'un animateur peut d'abord
 * passer par /login ou l'accueil avant de s'inscrire. Le code est gardé
 * (lib/parrainage) jusqu'à l'inscription.
 */
const CaptureParrainage: React.FC = () => {
  const { search } = useLocation();
  useEffect(() => {
    capturerParrainage(search);
  }, [search]);
  return null;
};

export default CaptureParrainage;
